import React from 'react';

function OverflowError({
    currentValue,
    allowedValue,
    overflowType,
    newPlanName
}) {
    return (
        <div className='d-flex w-100 h-100 text-center justify-content-center align-items-center flex-column'>
            <div>
                <img
                    height={"300px"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/OverflowError.png`}
                />
                <div className='font-size-6'>
                    Subscription change cannot be completed. Please see below summary.
                </div>
                <div className='font-size-4'>
                    In {newPlanName} plan { allowedValue } {overflowType} are allowed. You currently have {currentValue} {overflowType}.
                </div>
                <div className='font-size-4'>
                    Please remove extra {overflowType} before you start subscription change process.
                </div>
            </div>
        </div>
    )
}

export function RoleOverflowError({
    newPlanName
}) {
    return (
        <div className='d-flex w-100 h-100 text-center justify-content-center align-items-center flex-column'>
            <div>
                <img
                    height={"300px"}
                    src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/OverflowError.png`}
                />
                <div className='font-size-6'>
                    Subscription change cannot be completed. Please see below summary.
                </div>
                <div className='font-size-4'>
                    In { newPlanName } plan, only 3 default Roles are allowed. You currently have extra Roles defined in your app(s).
                </div>
                <div className='font-size-4'>
                    Please delete those extra Roles in all your apps before you start the subscription change process.
                </div>
            </div>
        </div>
    )
}

export default OverflowError;